import {
  getBenefitStatus,
  getBenefitStatusFromRechargeService,
  createCheckoutCoreSession as requestCheckoutCoreSession,
  getCheckoutUrlV2,
  getRecurrenceStatus,
} from "../api/smartcheckout";

const getSmartcheckoutUrlV2 = async (msisdn, channel, recipient, productId, origin) => {
  const response = await getCheckoutUrlV2(msisdn, {
    msisdn,
    channel,
    recipient,
    productId,
    origin,
  });

  return response;
};

const createCheckoutCoreSession = async ({
  msisdn,
  channel,
  recipient,
  offerId,
  ipAddress,
  tags,
}) => {
  const response = await requestCheckoutCoreSession(msisdn, {
    channel,
    payer: msisdn,
    recipient: recipient || msisdn,
    offer_id: offerId,
    ...(ipAddress && { ip_address: ipAddress }),
    ...(tags && Object.keys(tags).length > 0 && { tags }),
  });

  return response;
};

const getSmartcheckoutBenefitStatus = async (identifier, correlationId) => {
  return getBenefitStatus(identifier, correlationId);
};

// Fluxo novo, dos canais que obtem o callback pelo recharge-service. Separado de proposito:
// o caminho do becrux acima nao muda, e some inteiro quando o legado morrer.
const getSmartcheckoutBenefitStatusFromRechargeService = async (identifier, correlationId) => {
  return getBenefitStatusFromRechargeService(identifier, correlationId);
};

const getSmartcheckoutRecurrenceStatus = async (identifier, correlationId) => {
  return getRecurrenceStatus(identifier, correlationId);
};

export {
  getSmartcheckoutUrlV2,
  getSmartcheckoutBenefitStatus,
  getSmartcheckoutBenefitStatusFromRechargeService,
  createCheckoutCoreSession,
  getSmartcheckoutRecurrenceStatus,
};
